import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  max-width: var(--maxWidth);
  margin: 0 auto;
  justify-content: center;
`;
export const Image = styled.img``;
